module.exports = __webpack_public_path__ + "static/media/catamaran.75a00a87.JPG";